{
  "pageTitle": "Academics",
  "leadershipFocused": "A Leadership Focused",
  "WorldClassEducation": "World-Class Education",
  "heroSectionDescription": "At Manara, academic excellence is central to our mission. Students engage deeply in the classroom, taking intellectual responsibility for their learning and striving for high standards of achievement. Our rigorous curriculum is intentionally designed to develop executive skills such as analysis, organization, and independent thinking-qualities essential for university success and responsible citizenship. Guided by a dedicated faculty, students pursue excellence and grow into thoughtful, principled individuals.",
  "manaraPortrait": "Manara's Portrait",
  "ofGraduate": "of a graduate",
  "whatDoesOur": "What Does Our",
  "studentCentered": "What does our student",
  "curriculum": "-centered Curriculum offer?",
  "pursueYourPassionTitle1": "Explore Your",
  "pursueYourPassionTitle2": "Passion With",
  "pursueYourPassionTitle3": "The X-Term",
  "coursesCatalogError": "Failed to get courses catalog",
  "quarter": "Q",
  "upcomingEvents": "Upcoming Events",
  "pastEvents": "Past Events",
  "noUpcomingEvents": "No Upcoming Events",
  "noPastEvents": "No Past Events"
}
